// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3TB4k","buttons":"Footer_buttons__3bcBV"};